import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { ITRepairInfoService } from "../../../../../services/it-repair/itRepairInfo.service";

interface IVariable {
  id: string;
  body: any;
}

export const useUpdateRTR = () => {
  const queryClient = useQueryClient();
  const { mutate, ...restMutation } = useMutation({
    mutationFn: ({ id, body }: IVariable) => ITRepairInfoService.updateITRepairInfo(id, body),
  });

  const updateRTRequest = (
    vars: IVariable,
    options?: {
      onSuccess?: (r: any) => void;
      successText?: string;
      errorText?: string;
    },
  ) => {
    mutate(vars, {
      onSuccess(response: any) {
        queryClient.invalidateQueries({
          queryKey: ["repair-tools-requests"],
        });
        notification.success({
          message: "Thành công!",
          description: options?.successText ?? `Duyệt yêu cầu thành công.`,
        });
        if (options?.onSuccess) options.onSuccess(response);
      },
      onError() {
        notification.error({
          message: "Thất bại",
          description: options?.errorText ?? `Duyệt yêu cầu thất bại.`,
        });
      },
    });
  };
  return { mutate, updateRTRequest, ...restMutation };
};
